export default "__VITE_PUBLIC_ASSET__7c7d067e__"